// extracted by mini-css-extract-plugin
module.exports = {"main":"CustomerVoiceView_main_2LAaN","main_title":"CustomerVoiceView_main_title_2s7Ks"};